import banquetInquiryAPI from "../../services/banquetInquiryAPI";

const appError = {
  applicationError: {
    hasError: true,
    error: [
      " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
    ]
  }
};

export default {
  healthCheck: ({ commit }) => {
    try {
      banquetInquiryAPI
        .healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            return;
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  createBanquetInquiry: ({ commit }, { payload, setLoading, nextStep }) => {
    try {
      banquetInquiryAPI
        .createBanquetInquiry(payload)
        .then(response => {
          if (response && response.status === 200 && response.data) {
            setLoading(false);
            commit("setBanquetInquiryDetails", response.data);
            nextStep();
            commit("setErrors", {
              banquetInquiryError: {
                hasError: false,
                error: []
              }
            });
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(err => {
          console.log(err);
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data &&
            err.response.data.errors
          ) {
            let formattedErrors = [];
            (Object.values(err.response.data.errors) || []).map(error => {
              if (Array.isArray(error)) {
                formattedErrors.push(...error);
              } else {
                formattedErrors.push(error);
              }
            });
            commit("setErrors", {
              banquetInquiryError: {
                hasError: true,
                error: formattedErrors
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  setValue: ({ commit }, value) => {
    commit("setValue", value);
  },
  setErrors: ({ commit }, error) => {
    commit("setErrors", error);
  }
};
